<template>
    <div>
        <ly-crud ref="lycrud"  v-bind="crudConfig" >
            <template v-slot:customHandle="slotProps">
                <el-popconfirm title="确定要删除该用户吗?" @confirm="handleClick(slotProps.row,'Delete')" width="170">
                    <template #reference>
                        <span class="table-operate-btn" v-show="hasPermission(this.$route.name,'Delete') && !slotProps.row.is_delete">删除</span>
                    </template>
                </el-popconfirm>
                <el-popconfirm title="确定要重置密码吗?默认密码是123456" @confirm="handleClick(slotProps.row,'Resetpass')" width="170">
                    <template #reference>
                        <span class="table-operate-btn" v-show="hasPermission(this.$route.name,'Resetpass')">重置密码</span>
                    </template>
                </el-popconfirm>
            </template>
        </ly-crud>
    </div>
</template>

<script lang="jsx">
    import {baobeiArea,UsersUsers,UsersAgentusers,UsersAgentusersAdd,UsersAgentusersDelete,UsersAgentusersEdit,UsersAgentusersdisableEdit,UsersAgentusersResetpassword} from '@/api/api'
    import LyCrud from "@/components/lycrud";
    import templateData from "@/components/dict/crudTemplateData"
    import { _h,_resolveComponent } from 'vue';
    export default {
        name: "agentUserManage",
        components: {LyCrud},
        data(){
            let salerList = this.getSalerList()
            let areaList = this.getAreaList()
            return{
                defaultImg:require('../../assets/img/agentavatar.png'),
                //crud配置
                crudConfig:{
                    //crud请求方法配置
                    crudRequest:{
                        add:UsersAgentusersAdd,
                        del:UsersAgentusersDelete,
                        edit:UsersAgentusersEdit,
                        search:UsersAgentusers,
                    },
                    //搜索栏目配置
                    searchBar:{
                        showSearchBar:true,//显示搜索栏目
                        searchColums:[
                            {label:'代理商',type:'input',prop:'agent_name',width:140,maxlength:60,placeholder:'请输入代理商'},
                            {label:'姓名',type:'input',prop:'name',width:100,maxlength:60,placeholder:'请输入姓名'},
                            {label:'手机号',type:'input',prop:'username',width:150,maxlength:60,placeholder:'请输入手机号'},
                            {label:'所属销售',type:'select',prop:'saler',width:120,placeholder:'请选择',
                                options:salerList
                            },
                            {label:'区域',type:'select',prop:'area',width:120,placeholder:'请选择',
                                options:areaList
                            },
                        ]
                    },
                    //显示分页
                    showPagination:true,
                    //分页配置
                    pageparams: {
                        limit: 10,//每页显示的条数(默认每页显示10条)//非必填
                        //pageSizes:[10,20,30,40,50,200],//非必填
                        // layout:'total, sizes, prev, pager, next, jumper',//非必填
                    },
                    //crud按钮配置
                    rowHandle:{
                        width: 180,//操作列宽度,0表示不显示表格操作列
                        fixed:"right",//固定操作列在右侧
                        permission:{//增删改查按钮权限控制（是否显示）
                            add:this.hasPermission(this.$options.name,'Create'),//bool型 this.$options.name获取当前组件的name本例为userManageCrud
                            del:false,
                            edit:this.hasPermission(this.$options.name,'Update'),
                            search:this.hasPermission(this.$options.name,'Search'),
                            detail:false,
                        }
                    },
                    //crud弹窗属性
                    formOptions: {
                        width:'45%',//dialog弹窗宽度：类型：百分比或字符串
                        gutter: 20, // Layout布局栅格间隔
                    },
                    //crud表格属性
                    tableOptions:{
                        border:true,
                        showHeader:true,
                    },
                    showSelectable:true,//表格显示复选项框
                    //table表头列
                    tableColumns:[
                         // {label:'用户头像',type:'image',prop:'avatar',minWidth:'60',sortable: false,hidden:false,render:(row)=>{
                         //     let elImage = resolveComponent('el-image')//全局组件需要先resolveComponent解析该组件再render渲染，不然该标签会出现原样输出
                         //     return h(elImage,{
                         //          src:row.avatar ? row.avatar : this.defaultImg,
                         //          previewSrcList:[row.avatar ? row.avatar : this.defaultImg],//开启预览，原preview-src-list属性在h渲染方法中，-后字母大写代替即可：previewSrcList
                         //          previewTeleported:true,//插入至body元素上
                         //          style:"width: 30px;height: 30px",
                         //     },)
                         //  }
                         // },
                        {label:'ID',prop:'id',type:'input',minWidth:'100',sortable: false,hidden:true,
                            form:{
                                 //表单属性
                                 span:24,
                                 hidden:true,//编辑时隐藏，添加时去除
                             }
                        },
                        {label:'用户头像',type:'image-avatar',prop:'avatar',minWidth:'60',sortable: false,hidden:false,
                            render:(row)=>{
                                //jsx语法
                                return <el-image src={row.avatar ? row.avatar : this.defaultImg} style="width: 30px;height: 30px" preview-teleported={true} preview-srcList={[row.avatar ? row.avatar : this.defaultImg]}></el-image>
                            },
                            form:{
                                //表单属性
                                span:24,
                                // width:80,头像大小默认80px
                                defaultValue:require('../../assets/img/agentavatar.png'),//新增时的默认值
                            }

                         },
                         {label:'代理商',prop:'agent_name',type:'input',minWidth:'110',sortable: false,hidden:false,
                            form:{
                                //表单属性
                                span:24,
                                rules: [{ required: true, message: '代理商必填项' ,trigger: 'blur'}],
                                placeholder: '请输入代理商',
                            }
                         },
                         {label:'姓名',prop:'name',type:'input',minWidth:'80',sortable: false,hidden:false,
                            form:{
                                //表单属性
                                span:24,
                                rules: [{ required: true, message: '姓名必填项',trigger: 'blur' }],
                                placeholder: '请输入姓名',
                            }
                         },
                         {label:'邮箱',prop:'email',type:'input',minWidth:'150',sortable: false,hidden:false,
                            form:{
                                //表单属性
                                span:24,
                                rules: [{ required: true, message: '邮箱必填项',trigger: 'blur' }],
                                placeholder: '请输入邮箱',
                            }
                         },
                         {label:'区域',prop:'area',type:'select',minWidth:'100',sortable: false,hidden:false,
                            render:(row)=>{
                                //table显示样子
                                return row.area_name
                            },
                            form:{
                                //表单属性
                                span:24,
                                rules: [{ required: true, message: '请选择区域' ,trigger: 'blur'}],
                                options:areaList,
                            }
                        },
                         {label:'所属销售',prop:'parent',type:'select',minWidth:'150',sortable: false,hidden:false,
                            render:(row)=>{
                                //table显示样子
                                return row.agentinfo.id != ''?row.agentinfo.name+':' +row.agentinfo.mobile:''
                            },
                            form:{
                                //表单属性
                                span:24,
                                rules: [{ required: true, message: '请选择所属销售',trigger: 'blur' }],
                                options:salerList,
                            }
                        },
                         {label:'手机号',prop:'username',type:'input',minWidth:'150',sortable: false,hidden:false,
                            form:{
                                //表单属性
                                span:24,
                                rules: [{ required: true, message: '手机号必填项',trigger: 'blur' }],
                                placeholder: '请输入手机号',
                                editDisabled:false,//编辑时是否禁用
                            }
                         },
                         {label:'密码',prop:'password',type:'input',minWidth:'110',sortable: false,hidden:true,
                            form:{
                                //表单属性
                                span:24,
                                rules: [{ required: true, message: '密码必填项' ,trigger: 'blur'}],
                                placeholder: '请输入密码',
                                showPassword:true,
                            }
                         },
                         {label:'状态',prop:'is_active',type:'radio',minWidth:'100',sortable: false,hidden:false,
                             render: (row) =>{
                                //jsx语法
                                return <el-switch v-model={row.is_active} preview-teleported={true} active-color="#13ce66" inactive-color="#ff4949" onChange={()=>this.changeStatus(row)}></el-switch>
                              },
                             form:{
                                 //表单属性
                                 span:24,
                                 options:templateData.STATUS_BOOL,//radio选项属性值
                                 defaultValue:true,//新增时的默认值
                                 // valueChange(e){//值变化回调事件
                                 //     console.log(e,'---变化的值')
                                 // },
                             }
                         },
                         {label:'创建时间',prop:'create_datetime',minWidth:'150',sortable: false,hidden:false},
                    ],
                },

            }
        },
        methods:{
            setFull(){
                this.$refs.lycrud.setFull()
            },
            //自定义操作列按钮方法
            handleClick(row,flag){
                let vm = this
                if(flag=='Resetpass'){
                    UsersAgentusersResetpassword({id:row.id}).then(res=>{
                        if(res.code == 2000) {
                            vm.$message.success(res.msg)
                            vm.$refs.lycrud.handleRefresh()//刷新表格数据
                        } else {
                            vm.$message.warning(res.msg)
                        }
                    })
                }else if(flag=='Delete'){
                    UsersAgentusersDelete({id:row.id}).then(res=>{
                        if(res.code == 2000) {
                            vm.$message.success(res.msg)
                            vm.$refs.lycrud.handleRefresh()//刷新表格数据
                        } else {
                            vm.$message.warning(res.msg)
                        }
                    })
                }
            },
            changeStatus(row) {
                let vm = this
                let flat = row.is_active
                row.is_active = !row.is_active
                let _temp_is_allow = 1
                vm.$confirm('确定修改状态吗？','提醒',{
                    closeOnClickModal:false,
                    type: "warning"
                }).then(_res=>{
                    flat ? row.is_active = true : row.is_active = false
                    if(row.is_active){
                        _temp_is_allow = 1
                    }else{
                        _temp_is_allow = 0
                    }
                    UsersAgentusersdisableEdit({id:row.id}).then(res=>{
                        if(res.code == 2000) {
                            vm.$message.success(res.msg)
                            vm.$refs.lycrud.handleRefresh()//刷新表格数据
                        } else {
                            vm.$message.warning(res.msg)
                        }
                    })
                }).catch(()=>{

                })
            },
            getSalerList(){
                let slist = []
                UsersUsers({page:1,limit:999,onlysaler:true,is_active:1}).then(res=>{
                    if(res.code === 2000){
                        res.data.data.forEach(item=>{
                            slist.push({
                                value:item.id,
                                label:item.name+":"+item.mobile
                            })
                        })
                    }
                })
                return slist
            },
            getAreaList(){
                let slist = []
                baobeiArea({page:1,limit:999,status:1}).then(res=>{
                    if(res.code === 2000){
                        res.data.data.forEach(item=>{
                            slist.push({
                                value:item.id,
                                label:item.name
                            })
                        })
                    }
                })
                return slist
            }
        },
    }
</script>

<style scoped>

</style>